import { createRouter, createWebHistory } from "vue-router";
import DigitalDriverCards from "@/views/DigitalDriverCards";
import Home from "@/views/Home";
import VehicleRegistrationPlates from "@/views/VehicleRegistrationPlates";
import Documents from "@/views/Documents";
import Contacts from "@/views/Contacts";
import NotFound from "@/views/NotFound";

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/digital-driver-cards",
    name: "DigitalDriverCards",
    component: DigitalDriverCards,
  },
  {
    path: "/vehicle-registration-plates",
    name: "VehicleRegistrationPlates",
    component: VehicleRegistrationPlates,
  },
  {
    path: "/documents",
    name: "Documents",
    component: Documents,
  },
  {
    path: "/contacts",
    name: "Contacts",
    component: Contacts,
  },
  {
    path: "/:pathMatch(.*)",
    component: NotFound,
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior() {
    return { top: 0 };
  },
});

export default router;
